module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root,
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "creative-scale-place-holder"
  }), _c('div', {
    staticClass: "creative-scale-preview"
  }, [_c('creative-preview', {
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.facebookPage,
      "disabledButtons": _vm.disabledButtons,
      "landingPage": _vm.landingPage,
      "isTimeline": _vm.isTimeline,
      "mobilePreview": _vm.mobilePreview,
      "enableFormPreview": _vm.enableFormPreview,
      "showCreativeIdBottom": _vm.showCreativeIdBottom
    },
    on: {
      "loaded": _vm.scale,
      "creativePreviewUpdated": _vm.scale
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07b6295f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/creative-preview-scaled/CreativePreviewScaled.vue
// module id = 2000
// module chunks = 1